module.exports = "images/7ans.e7e9f6cb.png";